//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: () => ({
       usertype:'',
       form:{
          commentLevel:0,
          commentContent: '',
          relationType: 9, //2项目
          relationUserId: '', //关联标识
          relationId:'',
          userId: '', //用户id
       },
       zbList:[],
       forms:{
            degreeLevel: 0, //配合程度
            efficiencyLevel: 0, //工作效率评分
            qualityLevel: 0, //工作质量评分
            commentContent: '',
            relationType: 9, //9项目
            relationUserId: '', //关联标识
            relationId: '',
            userId: '', //用户id
       }
    }),
    methods: {
        //确定评价发包商
        ensureComment(){
            var form=''
            if(this.usertype==3){
                this.form.relationUserId= this.$route.query.relationUserId
                this.form.relationId = this.$route.query.relationId
                this.form.userId = getSession('user').id;
                if (this.form.commentLevel == 0) {
                    this.$message.error('请选择评价星级');
                    return
                }
                form= this.form
            }
            if(this.usertype==2){
                if (this.forms.degreeLevel == 0) {
                    this.$message.error('请选择配合程度评分');
                    return
                }
                if (this.forms.efficiencyLevel == 0) {
                    this.$message.error('请选择工作效率评分');
                    return
                }
                if (this.forms.qualityLevel == 0) {
                    this.$message.error('请选择工作质量评分');
                    return
                }
                this.forms.relationUserId= this.$route.query.relationUserId
                this.forms.userId = getSession('user').id;
                this.forms.relationId = this.$route.query.relationId;
                form= this.forms
            }
            this.$post('/sys/user/comment', form, function(res){
                if (res.code == 200) {
                    this.$message.success('评价成功!');
                    this.$router.back(-1);
                }
            },true)
        },

        // 获取中标人列表
        userInfo(){
            this.$get('/tra/project/bid/waitComment?projectId='+this.$route.query.projectId,function(res){
                if(res.code==200){
                    this.zbList = res.data
                }
            })
        }

    },
    mounted() {
       this.usertype= this.$route.query.usertype
       if(this.usertype==2){
        this.userInfo()
       }
    }
}
